// extracted by mini-css-extract-plugin
export default {"featuresDropdown":"style_featuresDropdown__kcivV","item":"style_item__YNHJ6","title":"style_title__FPcnJ","content":"style_content__mI0M0"};